import React from 'react';

import type { StateTermItem } from '@/utils/stateTerms';

/** Renders a data-driven state section (utils/stateTerms) like the hand-written ones. */
const StateTermsList = ({
  state,
  items,
}: {
  state: string;
  items: StateTermItem[];
}) => (
  <div>
    <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
      {state} Specific Terms
    </h2>
    <ol className="text-black mb-4 text-base list-decimal list-inside">
      {items.map((item, i) => (
        <li key={i}>
          {item.link && (
            <>
              <span
                className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
                onClick={() => window.open(item.link!.url, '_blank')}
              >
                {item.link.label}
              </span>{' '}
            </>
          )}
          {item.text}
        </li>
      ))}
    </ol>
  </div>
);

export default StateTermsList;
